var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({class:['gl-token', _vm.variantClass, _vm.viewOnlyClass]},_vm.$listeners),[_c('span',{staticClass:"gl-token-content"},[_vm._t("default"),_vm._v(" "),(!_vm.viewOnly)?_c('close-button',{staticClass:"gl-token-close",attrs:{"label":_vm.removeLabel},on:{"click":_vm.close}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }